<template>
  <form v-on:submit.prevent="addCandidature()">
    <div class="form-group">
      <input
        type="text"
        class="form-control"
        id="name"
        aria-describedby="emailHelp"
        :placeholder="this.contents.find(content => content.id_content === 103)?.title + '*'"
        v-model="name"
        required
      />
    </div>
    <div class="form-group">
      <input
        type="email"
        class="form-control"
        id="email"
        placeholder="Email*"
        v-model="email"
        required
      />
    </div>
    <div class="form-group">
      <input
        type="number"
        class="form-control"
        id="tlf"
        :placeholder="this.contents.find(content => content.id_content === 104)?.title + '*'"
        v-model="cellphone"
      />
    </div>
    <div class="form-group">
      <multiselect
        :placeholder="this.contents.find(content => content.id_content === 105)?.title"
        v-model="selected"
        :deselect-label="this.contents.find(content => content.id_content === 106)?.title"
        track-by="text"
        label="text"
        :options="options"
        :multiple="true"
      >
      </multiselect>
    </div>
    <div class="form-group">
      <input
        type="text"
        class="form-control"
        id="skills"
        v-model="skills"
        :placeholder="this.contents.find(content => content.id_content === 107)?.title"
      />
    </div>
    <div class="form-group">
      <input
        type="link"
        class="form-control"
        id="linkedin"
        v-model="linkedin"
        :placeholder="this.contents.find(content => content.id_content === 108)?.title"
      />
    </div>
    <div class="form-group">
      <textarea
        class="form-control"
        id="exampleFormControlTextarea1"
        rows="3"
        v-model="message"
        :placeholder="this.contents.find(content => content.id_content === 109)?.title"
      ></textarea>
    </div>
    <div class="form-group">
      <label class="custom-file-upload" @click="$refs.file.click()">
        <i class="fa fa-cloud-upload"></i> {{ fileName }}
      </label>
      <input
        id="file-upload"
        type="file"
        ref="file"
        @change="handleFileUpload()"
        accept=".pdf, .docx"
        required
      />
    </div>
    <div id="small">
      <small>*{{ this.contents.find(content => content.id_content === 110)?.title }}</small>
    </div>
    <div class="form-check">
      <input
        type="checkbox"
        class="form-check-input"
        id="exampleCheck1"
        v-model="check"
        required
      />
      <label class="form-check-label" for="exampleCheck1"
        >{{ this.contents.find(content => content.id_content === 111)?.title }}
        <a href=""
          ><router-link to="/privacity"
            >{{ this.contents.find(content => content.id_content === 112)?.title }}</router-link
          ></a
        ></label
      >
    </div>
    <button type="submit" class="btn btn-primary">{{ this.contents.find(content => content.id_content === 113)?.title }}</button>
  </form>
</template>
<script>
import Multiselect from "vue-multiselect";
import { mapGetters } from "vuex";
export default {
  components: { Multiselect },
  props: {
    contents: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selected: null,
      options: [],
      name: "",
      email: "",
      cv: "",
      linkedin: "",
      skills: "",
      message: "",
      image: null,
      file: "",
      fileName: "CV" ,
      scrolledToBottom: false,
      cellphone: "",
      check: false,
    };
  },
  created() {
    this.getAllSkills();
  },
  methods: {
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.fileName = this.file.name;
    },
    async addCandidature() {
      if (
        this.file.type ==
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        this.file.type == "application/pdf"
      ) {
        let id_skills = [];
        if (this.selected != null) {
          for (let i = 0; i < this.selected.length; i++) {
            id_skills.push(this.selected[i].value);
          }
        }
        try {
          let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "pt";
          await this.$store.dispatch("postSpontaneousApplication", {
            name: this.name,
            email: this.email,
            cv: this.file,
            linkedin: this.linkedin,
            skills: id_skills,
            about: this.message,
            otherSkills: this.skills,
            cellphone: this.cellphone,
          });
          this.$swal({
            title: lang === "pt" ? this.getMessage : "Application Sent! Thank you for your contact.",
            text: lang === "pt" ? this.getSubmessage : "Please check your email.",
            confirmButtonColor: "#f7941e",
            confirmButtonText: this.contents.find(content => content.id_content === 117)?.title,
          });
          this.name = "";
          this.email = "";
          this.file = "";
          this.fileName = "CV";
          this.linkedin = "";
          this.selected = null;
          this.skills = "";
          this.about = "";
          this.cellphone = "";
          this.check = false;
        } catch (err) {
          this.$swal({
            title: this.contents.find(content => content.id_content === 115)?.title,
            text: this.contents.find(content => content.id_content === 116)?.title,
            confirmButtonColor: "#f7941e",
            confirmButtonText: this.contents.find(content => content.id_content === 117)?.title,
          });
        } finally {
          this.load = false;
        }
      } else {
        this.$swal({
          title: this.contents.find(content => content.id_content === 118)?.title,
          text: this.contents.find(content => content.id_content === 119)?.title,
          confirmButtonColor: "#f7941e",
          confirmButtonText: "OK",
        });
      }
    },
    async getAllSkills() {
      try {
        await this.$store.dispatch("fetchSkills");
        for (let i = 0; i < this.getSkills.data.length; i++) {
          this.options.push({
            value: this.getSkills.data[i].id_skills,
            text: this.getSkills.data[i].name,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  computed: {
    ...mapGetters(["getSkills"]),
    ...mapGetters(["getMessage"]),
    ...mapGetters(["getSubmessage"]),
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
input[type="file"] {
  display: none;
}
.custom-file-upload {
  border-bottom: 2px solid grey;
  display: inline-block;
  font-weight: bold;
  color: grey;
  font-size: 20px;
  margin-top: 10px;
  padding: 6px 12px;
  cursor: pointer;
}
form {
  padding: 0px 0px 0px 0px;
  text-align: center;
}
h1 {
  padding: 20px;
}
.form-control {
  font-weight: bold;
  border: 0px solid black;
  border-bottom: 2px solid grey;
  border-radius: 0px;
}
.form-control:focus {
  font-weight: bold;
  font-size: 20px;
  color: #f7941e;
  box-shadow: none;
  border-color: #f7941e;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
textarea {
  resize: none;
}
.form-check {
  text-align: center;
}
button {
  border: 0px;
  margin-top: 20px;
  background: #f7941e;
}
button:focus {
  box-shadow: none;
}
button:hover {
  box-shadow: #888888;
  background-color: #888888;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
}
#small {
  text-align: left;
}
a {
  color: #f7941e;
}

@media (max-width: 1000px) {
  form {
    padding: 0px 20px 0px 20px;
    text-align: center;
  }
  h1 {
    padding: 0px 0px 20px 0px;
  }
  .form-check {
    text-align: center;
  }
  button {
    border: 0px;
    margin-top: 20px;
    background: #f7941e;
  }
}
</style>
